<template>
  <sp-card class="panel" scrollable-content>
    <sp-heading v-if="preamble" level="2" class="panel__preamble">{{ preamble }}</sp-heading>

    <sp-alert v-if="info" type="info" icon>
      {{ info }}
    </sp-alert>

    <slot />
  </sp-card>
</template>

<script setup>
defineProps({
  preamble: {
    type: String,
    default: undefined,
  },
  info: {
    type: String,
    default: undefined,
  },
});
</script>

<style scoped lang="scss">
.panel__preamble {
  text-align: center;
}
sp-alert {
  margin-bottom: var(--sp-ref-scale-16);
}
</style>
